import { render, staticRenderFns } from "./CoordinationEventEditTable.vue?vue&type=template&id=f76edc0c&scoped=true"
import script from "./CoordinationEventEditTable.vue?vue&type=script&lang=ts"
export * from "./CoordinationEventEditTable.vue?vue&type=script&lang=ts"
import style0 from "./CoordinationEventEditTable.vue?vue&type=style&index=0&id=f76edc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76edc0c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/client-settings/coordination/event/coordination-event-edit-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2Fcoordination%2Fevent%2FCoordinationEventEditTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports